import { createContext } from "react";

const UserContext = createContext({
  logout: () => {},
  userLink: null,
  isAuthed: false,
});

export default UserContext;
